/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateKeyForm,
  CreateKeyForm$Outbound,
  CreateKeyForm$outboundSchema,
} from "../components/createkeyform.js";

export type CreateAPIKeySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreateAPIKeyRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  createKeyForm: CreateKeyForm;
};

/** @internal */
export type CreateAPIKeySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateAPIKeySecurity$outboundSchema: z.ZodMiniType<
  CreateAPIKeySecurity$Outbound,
  CreateAPIKeySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createAPIKeySecurityToJSON(
  createAPIKeySecurity: CreateAPIKeySecurity,
): string {
  return JSON.stringify(
    CreateAPIKeySecurity$outboundSchema.parse(createAPIKeySecurity),
  );
}

/** @internal */
export type CreateAPIKeyRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  CreateKeyForm: CreateKeyForm$Outbound;
};

/** @internal */
export const CreateAPIKeyRequest$outboundSchema: z.ZodMiniType<
  CreateAPIKeyRequest$Outbound,
  CreateAPIKeyRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    createKeyForm: CreateKeyForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      createKeyForm: "CreateKeyForm",
    });
  }),
);

export function createAPIKeyRequestToJSON(
  createAPIKeyRequest: CreateAPIKeyRequest,
): string {
  return JSON.stringify(
    CreateAPIKeyRequest$outboundSchema.parse(createAPIKeyRequest),
  );
}
